<script>
export default {
  name: 'General',
}
</script>

<template>
  <NuxtLayout name="default">
    <slot name="sidebar" />
  </NuxtLayout>
</template>
